import React from "react";

export default function AgeChart({ ageData }) {
  const formattedData = React.useMemo(() => {
    if (!ageData || !Array.isArray(ageData)) {
      return [];
    }
    
    return ageData.map(item => {
      if (typeof item === 'object') {
        if (item.label && typeof item.value !== 'undefined') {
          return {
            age: item.label,
            percent: `${item.value}%`
          };
        }
        if (item.age && item.percent) {
          return item;
        }
      }
      return { age: 'Unknown', percent: '0%' };
    });
  }, [ageData]);

  if (formattedData.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No age data available
      </div>
    );
  }

  const maxPercent = Math.max(...formattedData.map(item => {
    const percentStr = item.percent.replace('%', '');
    return parseFloat(percentStr) || 0;
  }));

  return (
    <div className="campaignsChartTop__ageChart">
      {formattedData.map((item, index) => {
        const percentNum = parseFloat(item.percent.replace('%', '')) || 0;
        const widthPercent = maxPercent > 0 ? (percentNum / maxPercent) * 100 : 0;
        
        return (
          <div className="campaignsChartTop__ageChart__row" key={index}>
            <div className="campaignsChartTop__ageChart__text">{item.age}</div>
            <div className="campaignsChartTop__ageChart__line">
              <span style={{ width: `${widthPercent}%` }}></span>
            </div>
            <div className="campaignsChartTop__ageChart__text">
              {item.percent.includes('%') ? item.percent : `${item.percent}%`}
            </div>
          </div>
        );
      })}
    </div>
  );
}